import { Status } from '@philo/web-shared';
import { Action } from 'redux';
import { SECURE_BASE_URL } from '../../config';
import DEFAULT_STATE, { DeviceAuthState } from '../defaults/device-auth';

export const CLEAR_DEVICE_AUTH_VALIDATION = 'APP_CLEAR_DEVICE_AUTH_VALIDATION';
export const SET_IS_ACTIVATING_DEVICE = 'APP_SET_IS_ACTIVATING_DEVICE';
export const SET_DEVICE_AUTH_CODE = 'APP_SET_DEVICE_AUTH_CODE';
export const SET_DEVICE_AUTH_CODE_STATUS = 'APP_SET_DEVICE_AUTH_CODE_STATUS';
export const UPDATE_DEVICE_AUTH_STATE = 'UPDATE_DEVICE_AUTH_STATE';
export const SET_DEVICE_AUTH_CODE_VALIDATION_ERROR = 'APP_SET_DEVICE_AUTH_CODE_VALIDATION_ERROR';
export const SET_DEVICE_AUTH_REDIRECT_URL = 'APP_SET_DEVICE_AUTH_REDIRECT_URL';
export const SET_IS_VALIDATING_DEVICE_AUTH_CODE = 'APP_SET_IS_VALIDATING_DEVICE_AUTH_CODE';

export const VALIDATE_DEVICE_AUTH_CODE_URL = `${SECURE_BASE_URL}/auth/update/activate`;

export type DeviceAuthAction = Action<string> & Partial<DeviceAuthState>;

export function setDeviceAuthCode(code?: string): DeviceAuthAction {
  return {
    type: SET_DEVICE_AUTH_CODE,
    code,
  };
}

export function setIsValidatingDeviceAuthCode(isValidatingCode: boolean): DeviceAuthAction {
  return {
    type: SET_IS_VALIDATING_DEVICE_AUTH_CODE,
    isValidatingCode,
  };
}

export function setDeviceAuthCodeValidationError(validationError: string): DeviceAuthAction {
  return {
    type: SET_DEVICE_AUTH_CODE_VALIDATION_ERROR,
    validationError,
  };
}

export function setDeviceAuthCodeStatus(status?: Status): DeviceAuthAction {
  return {
    type: SET_DEVICE_AUTH_CODE_STATUS,
    status,
  };
}

export function clearDeviceAuthValidation(): DeviceAuthAction {
  const { validationError, status } = DEFAULT_STATE;
  return {
    type: CLEAR_DEVICE_AUTH_VALIDATION,
    status,
    validationError,
  };
}

export function setDeviceAuthRedirectURL(redirectURL?: string): DeviceAuthAction {
  return {
    type: SET_DEVICE_AUTH_REDIRECT_URL,
    redirectURL,
  };
}

export function setIsActivatingDevice(isActivatingDevice: boolean): DeviceAuthAction {
  return {
    type: SET_IS_ACTIVATING_DEVICE,
    isActivatingDevice,
  };
}

export function updateDeviceAuthState(deviceAuthState: Partial<DeviceAuthState>): DeviceAuthAction {
  return {
    type: UPDATE_DEVICE_AUTH_STATE,
    ...deviceAuthState,
  };
}
